import React from 'react'
import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import { Cake } from '@mui/icons-material'
import { Score } from '../../../../types/ConnectionBoard'

interface ConnectionSignalsProps {
  scoresWithReason: Score[]
}

const ConnectionSignals = ({ scoresWithReason }: ConnectionSignalsProps) => {
  return (
    <Table size="small" sx={{ my: 1 }}>
      <TableBody>
        {scoresWithReason.map(({ reason, value, field }) => {
          const isBirthdayToday = reason?.includes('Birthday') && value === 0
          return (
            <TableRow key={reason}>
              <TableCell className={field ? `connection-signal-${field}` : undefined} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {reason}
                {isBirthdayToday ? <Cake color="primary" sx={{ ml: 1, height: 18 }} /> : null}
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

export default ConnectionSignals
